import React, { useState, forwardRef, useEffect } from "react";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import { todayDate } from "../utility/common/helpers/TodayDate";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { DateInput, DateInputDisabled } from "../utility/common/helpers/DateComponent";
import WcrPdf from "./WcrPdf";
import { getAllRecordsWeldingProcess } from "../../Services/weldingprocess-services";
import { normalstyle, RenderIf } from "../../functions/welding-functions";
import { removeDuplicates } from "../utility/grid/functions/gbcs-functions";
import { BiSelectMultiple } from "react-icons/bi";
import MultiValuePopUp from "../utility/ui/modals/MultiValuePopUp";
import { TypeData } from "../utility/common/TransactionComponents/TransactionEntity";
import { showInfo } from "../utility/ui/notifications/Toaster";
import { getAllWelder } from "../../Services/Welder-services";
import { DotLoader } from "react-spinners";

const WelderContinuityRecord = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  // const [widata, setwidata] = useState(null);
  const [welderData, setWelderData] = useState([]);
  const [reload, setReload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [pcategories, setPcategories] = useState(null);
  const [filteredPcategories, setFilteredPcategories] = useState(null);
  const [datevalue, setdatevalue] = useState(false);
  const [selectedWelderData, setSelectedWelderData] = useState([]);

  const [wiobj, setwiobj] = useState({
    WI_Project_No: "",
    WI_Joint_No: "",
    WI_Welder_Id: [],
    WI_Welder_Name: [],
    WI_Process: "",
    WI_ProcessCategory: "",
    WI_Type: "",
    WI_From_Date: "",
    WI_To_Date: "",
    WI_Slip_Status: "",
    WPS_Rev_no: "",
    WI_FileFormat: "",
    WI_Last_Weld: false,
    WI_SlipDate: "",
  });

  const [popUp, setPopUp] = useState({
    name: "",
    type: "",
    key: "",
    value: "",
  });

  const [error, setError] = useState({
    WI_Project_No: {},
    WI_Joint_No: {},
    WI_Welder_Id: {},
    WI_From_Date: {},
    WI_To_Date: {},
    WI_Slip_Status: {},
  });

  const fetchwidata = async () => {
    setLoading(true);
    //const result = await getwiwelders();
    const resultWelders = await getAllWelder();
    // // Step 1: Remove duplicates from result based on wld_code
    // let uniqueWldData = result ? removeDuplicates(x => x.WI_Welder_Id, result) : [];

    let uniqueActiveWlders = resultWelders ? removeDuplicates(x => x.SK, resultWelders) : [];

    // // Step 2: Create a Set of active welder IDs for fast lookup
    // const activeWelderIds = new Set(resultWelders?.map(w => w.SK) || []);

    // // Step 3: Filter only those welders who are present in active list
    // const matchedWelders = uniqueWldData?.filter(w => {
    //   return activeWelderIds.has(w.WI_Welder_Id);
    // }) || [];

    // // Step 4: Set the filtered data
    // setwidata(matchedWelders);
    setWelderData(uniqueActiveWlders);
    setLoading(false);
  };


  useEffect(() => {
    fetchwidata();
    fetchWeldingProcess();
  }, []);

  useEffect(() => {
    if (reload) {
      setReload(false);
    }
  }, [reload]);

  const fetchWeldingProcess = async () => {
    const result = await getAllRecordsWeldingProcess();
    setFilteredPcategories(result ? removeDuplicates(x => x.wld_p_category, result) : [])
    setPcategories(result);
  };

  const handleSubmit = async (e) => {
    console.log("WCR handleSubmit called");
    console.log("WCR wiobj:", wiobj);
    console.log("WCR Welder IDs:", wiobj.WI_Welder_Id);
    console.log("WCR Welder ID count:", wiobj.WI_Welder_Id?.length);

    if (!wiobj.WI_Welder_Id || wiobj.WI_Welder_Id.length === 0) {
      console.log("WCR No welder selected, showing info message");
      showInfo("Please select at least one Welder Code");
      return;
    }

    console.log("WCR Validation passed, setting showForm to true");
    setShowForm(true); // Proceed to show PDF
  };

  const handleCheckboxClick = () => {
    setwiobj(prevState => ({
      ...prevState,
      WI_Last_Weld: !prevState.WI_Last_Weld,
      WI_From_Date: ""
    }));
    setdatevalue(false)
    setShowForm(false);
  };

  const showPopUp = (name, type, key, value) => {
    if (!welderData || welderData.length === 0) {
      return;
    }
    setPopUp({ name, type, key, value });
  };

  const setPopUpData = (data) => {
    console.log("WCR setPopUpData called with:", data);
    if (data.name === "Welder") {
      console.log("WCR Processing Welder data:", data.result);
      const welderIdsArr = data.result?.map(el => el.SK);
      const welderNamesArr = data.result?.map(el => el.wld_name);

      console.log("WCR Welder IDs array:", welderIdsArr);
      console.log("WCR Welder Names array:", welderNamesArr);

      setSelectedWelderData(data.result);
      setShowForm(false);
      setwiobj(prevState => ({
        ...prevState,
        WI_Welder_Id: welderIdsArr,
        WI_Welder_Name: welderNamesArr,
        WI_Process: ""
      }));

      console.log("WCR Updated wiobj with welder data");
    }
    setPopUp({ name: "", type: "", key: "", value: "" });
  };

  return (
    <Container fluid>
      {loading && (
        <div className="loader-overlay">
          <DotLoader size={80} className="pageloader" />
        </div>
      )}
      <Row className="RowHeight mb-4 ml-2">
        <Col md={12} className="ListTitle">Welder Continuity Record Filters</Col>
      </Row>
      <div className="px-2">
        <Row className="gx-3">
          <Col md={4}>
            <Form.Group className="g-input">
              <div className="d-flex align-items-center">
                <Form.Control
                  id="WI_Welder_Id"
                  name="WI_Welder_Id"
                  type="text"
                  readOnly
                  placeholder=" "
                  value={wiobj.WI_Welder_Id.join(", ")}
                  className="rightPaddingNpcil"
                />
                <Form.Label className="required-field" htmlFor="WI_Welder_Id">
                  Select Welder Code
                </Form.Label>
                <BiSelectMultiple
                  size={20}
                  onClick={() => showPopUp("Welder", "Multiple", "SK", wiobj.WI_Welder_Id)}
                  color={"#707070"}
                  style={{ marginLeft: "-2rem" }}
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="ListW-input-select">
              <div className="search-select">
                <SearchSelect
                  id="WI_ProcessCategory"
                  name="WI_ProcessCategory"
                  className={""}
                  stylegreen={normalstyle}
                  data={filteredPcategories}
                  valueField={"wld_p_category"}
                  value={wiobj?.WI_ProcessCategory}
                  labelField={"wld_p_category"}
                  placeholder=""
                  onChange={(ProjectList) => {
                    pcategories.filter((b) => {
                      return b.wld_p_category === ProjectList.value;
                    });
                    setwiobj((prev) => ({
                      ...prev,
                      WI_Process: "",
                      WI_ProcessCategory: ProjectList.value
                    }));
                  }}
                ></SearchSelect>
              </div>
              <Form.Label>Process</Form.Label>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="ListW-input-select">
              <div className="search-select">
                <SearchSelect
                  id="WI_Type"
                  name="WI_Type"
                  className={""}
                  stylegreen={normalstyle}
                  data={TypeData}
                  valueField={"wld_type"}
                  value={wiobj?.WI_Type}
                  labelField={"wld_type"}
                  placeholder=""
                  onChange={(e) => {
                    setwiobj((prev) => ({
                      ...prev,
                      WI_Type: e.value
                    }));
                  }}
                ></SearchSelect>
              </div>
              <Form.Label>Type</Form.Label>
            </Form.Group>
          </Col>
        </Row>
        <Row className="gx-3">
          {wiobj.WI_Last_Weld === false ?
            <Col md={4}>
              <DateInput
                divClass="Date-input w-100"
                label="Slip Creation Date From"
                className="groove_datecolor"
                name="WI_From_Date"
                sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy,sans-serif", zIndex: "0" }}
                todayDate={todayDate}
                obj={wiobj}
                setobj={setwiobj}
                datevalue={datevalue}
                setdatevalue={setdatevalue}
                todate={wiobj.WI_To_Date}
                setError={setError}
                status={error.WI_From_Date.status}
                message={error.WI_From_Date.message}
                form={setShowForm}
              />
            </Col>
            :
            <Col md={4}>
              <DateInputDisabled
                divClass="Date-input w-100"
                label="Slip Creation Date From"
                className="groove_datecolor"
                name="WI_From_Date"
                sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy,sans-serif", zIndex: "0" }}
                todayDate={todayDate}
                obj={wiobj}
                setobj={setwiobj}
                datevalue={datevalue}
                setdatevalue={setdatevalue}
                todate={wiobj.WI_To_Date}
                setError={setError}
                status={error.WI_From_Date.status}
                message={error.WI_From_Date.message}
                form={setShowForm}
              />
            </Col>}
          {wiobj.WI_Last_Weld === false ?
            <Col md={4}>
              <DateInput
                divClass="Date-input w-100"
                label="Slip Creation Date To"
                className="groove_datecolor"
                name="WI_To_Date"
                sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy,sans-serif", zIndex: "0", width: "300px", }}
                todayDate={todayDate}
                obj={wiobj}
                WI_Last_Weld={wiobj.WI_Last_Weld}
                fromdate={wiobj.WI_From_Date}
                setobj={setwiobj}
                setdatevalue={setdatevalue}
                datevalue={datevalue}
                setError={setError}
                status={error.WI_To_Date.status}
                message={error.WI_To_Date.message}
                form={setShowForm}
              />
            </Col>
            :
            <Col md={4}>
              <DateInputDisabled
                divClass="Date-input w-100"
                label="Slip Creation Date To"
                className="groove_datecolor"
                name="WI_To_Date"
                sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy,sans-serif", zIndex: "0", width: "300px", }}
                todayDate={todayDate}
                obj={wiobj}
                WI_Last_Weld={wiobj.WI_Last_Weld}
                fromdate={wiobj.WI_From_Date}
                setobj={setwiobj}
                setdatevalue={setdatevalue}
                datevalue={datevalue}
                setError={setError}
                status={error.WI_To_Date.status}
                message={error.WI_To_Date.message}
                form={setShowForm}
              />
            </Col>}
          <Col md={3}>
            <div>
              <span>
                Last Weld Date
              </span>
              &nbsp;&nbsp;
              <input
                type="checkbox"
                name="WI_Last_Weld"
                className="checkboxproject form-check-input"
                onClick={() => {
                  handleCheckboxClick()
                  setwiobj(prevState => ({
                    ...prevState,
                    WI_From_Date: "",
                  }));
                }}
                style={{ position: "relative", top: "2px" }}
                checked={wiobj.WI_Last_Weld}
              />
            </div>
          </Col>
        </Row>
      </div>
      <Row>
        <Col>
          <Button onClick={handleSubmit} className="btn-add-color semiBoldToggleButton rightAlignedButton" >
            Download
          </Button>
        </Col>
      </Row>
      <div style={{ position: "relative", top: "10000px" }}>
        {showForm && (
          <WcrPdf
            show={showForm}
            rowdata={wiobj}
            onHide={() => {
              console.log("WCR PDF component onHide called");
              setShowForm(false);
            }}
            setReload={setReload}
            reload={reload}
            backdrop="static"
            setLoading={(loading) => {
              console.log("WCR setLoading called with:", loading);
              setLoading(loading);
            }}
          />
        )}
      </div>
      <RenderIf isTrue={popUp.type === "Multiple"}>
        <MultiValuePopUp
          show={popUp.type === "Multiple"}
          onHide={() => setPopUp({ name: "", type: "", key: "", value: "" })}
          setSelected={setPopUpData}
          masterName={popUp.name}
          paramkey={popUp.key}
          paramvalue={popUp.value}
          welderData={welderData}
          selectedData={selectedWelderData}
          backdrop="static"
        />
      </RenderIf>
    </Container>
  );
});

export default WelderContinuityRecord;